export default function getFontsByPairingId(id, pairings) {
    return pairings.find(font => {
        return font.id === id;
    });
}
